import React, { useEffect, useState } from 'react';
import SingleClientV1 from './SingleClientV1';
import axios from 'axios';

const ClientV1 = () => {
    const [clients, setClients] = useState([]); 
    const BaseUrl = process.env.REACT_APP_BASE_URL;
  
    useEffect(() => {
      const fetchClients = () => {
        axios.get(`${BaseUrl}/clients`)
          .then(response => {
            console.log(response.data);
            setClients(response.data); 
          })
          .catch(error => {
            console.error('Error fetching clients:', error.response ? error.response.data : error.message);
          });
      };
  
      fetchClients(); 
    }, []); 
    return (
        <>
            <section className="clients-section" style={{
              marginTop:'0vh',padding:'0px',
            }}>
               
                <div className="auto-container">
                   
                    <SingleClientV1  clients={clients} />
                </div>
            </section>
        </>
    );
};

export default ClientV1;